import { useDispatch, useSelector } from "react-redux";
import { getCurrentContractAddresses } from "src/configs/address";
import ERC20MockContract from "src/contract-logic/logic/ERC20MockContract";
import StakingRTravaContract from "src/contract-logic/logic/StakingRTravaContract";
import { updateBalance } from "src/redux/balance-slice";

export default function useTravaBalance() {
  const accountAddress = useSelector((state) => state.accountSlice.address);
  const travaBalance = useSelector((state) => state.balanceSlice.travaBalance);
  const rTravaBalance = useSelector((state) => state.balanceSlice.rTravaBalance);
  const dispatch = useDispatch();

  async function fetchTravaBalance() {
    try {
      const { TRAVA_TOKEN_ADDRESS } = getCurrentContractAddresses();
      const contract = ERC20MockContract.getContractFactory(TRAVA_TOKEN_ADDRESS, { decimals: 18 });
      const balanceBN = await contract.getBalance(accountAddress);
      const rBalance = await StakingRTravaContract.balanceOf(accountAddress);
      dispatch(updateBalance({ travaBalance: balanceBN.toNumber(), rTravaBalance: rBalance }));
    } catch (error) {
      console.error(error);
      dispatch(updateBalance({ travaBalance: null }));
    }
  }

  async function updateTravaBalance() {
    await fetchTravaBalance();
  }

  return { travaBalance, fetchTravaBalance, updateTravaBalance, rTravaBalance };
}
